<div class="search-input-container" [class.fixed-width]="fixedWidth" [ngStyle]="getBackgroundWithOpacity()">
  <div class="search-icon">
    <tidy-image [src]="icon"></tidy-image>
  </div>
  <input
    class="search-input"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    [placeholder]="placeholder | translate"
    type="text"
  />
  <button
    class="clear-button"
    [class.hidden]="isInputEmpty"
    (click)="clearInput()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
